import { NavLink } from 'react-router-dom';
import { Brand } from './Brand';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';
import type { AnyIconName } from '@/components/ui/Icon';
import { Icon } from '@/components/ui';
import { cx } from '@/lib/cx';

interface NavItem {
  to: string;
  label: string;
  icon: AnyIconName;
  end?: boolean;
}

const SECTIONS: Array<{ title: string; items: NavItem[] }> = [
  {
    title: 'Cases',
    items: [
      { to: '/cases', label: 'All cases', icon: 'cases', end: true },
      { to: '/cases/new', label: 'New case', icon: 'plus' },
    ],
  },
  {
    title: 'Admin',
    items: [
      { to: '/admin/methodology', label: 'Methodology', icon: 'book' },
      { to: '/admin/funders', label: 'Funders', icon: 'bank' },
      { to: '/admin/usage', label: 'Usage', icon: 'chart' },
    ],
  },
];

const linkClass = ({ isActive }: { isActive: boolean }) =>
  cx(
    'flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors',
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent',
    isActive
      ? 'bg-accent-soft text-accent-strong'
      : 'text-ink-soft hover:bg-surface-2 hover:text-ink',
  );

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <div className="flex h-full flex-col">
      <div className="px-5 pb-6 pt-6">
        <Brand />
      </div>
      <nav aria-label="Main" className="flex-1 space-y-6 overflow-y-auto px-3">
        {SECTIONS.map((s) => (
          <div key={s.title}>
            <h2 className="mb-2 px-3 font-sans text-xs font-medium uppercase tracking-wider text-ink-soft/80">
              {s.title}
            </h2>
            <ul className="space-y-0.5">
              {s.items.map((item) => (
                <li key={item.to}>
                  <NavLink to={item.to} end={item.end} className={linkClass} onClick={onNavigate}>
                    <Icon name={item.icon} />
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
      <div className="flex items-center gap-1 border-t border-line p-3">
        <UserMenu />
        <ThemeToggle />
      </div>
    </div>
  );
}
